(() => {
  const controllers = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (scope = document) => {
    scope.querySelectorAll('[data-measure-guide]').forEach((drawer) => {
      if (controllers.has(drawer)) return;
      const video = drawer.querySelector('.ew-measure-guide-video__frame video');
      const button = drawer.querySelector('[data-measure-video-sound]');
      if (!video || !button) return;
      const root = drawer.closest('[data-premium-product]');
      const events = new AbortController();
      const options = { signal: events.signal };
      let open = false;
      let generation = 0;
      let disposed = false;
      const isOpen = () => !disposed && drawer.isConnected && !drawer.hidden && drawer.getAttribute('aria-hidden') !== 'true';
      const syncSound = () => {
        button.setAttribute('aria-pressed', String(!video.muted));
        button.querySelector('[data-sound-on]').hidden = !video.muted;
        button.querySelector('[data-sound-off]').hidden = video.muted;
      };
      const reset = () => {
        generation += 1;
        video.pause();
        try { video.currentTime = 0; } catch (_) {}
        video.muted = true;
        syncSound();
      };
      const play = () => {
        const attempt = ++generation;
        const result = video.play();
        result?.then(() => {
          if (!isOpen() || document.hidden) reset();
        }).catch(() => {
          if (attempt !== generation) return;
          video.muted = true;
          syncSound();
        });
      };
      const syncDrawer = () => {
        const next = isOpen();
        if (next === open) return;
        open = next;
        reset();
        if (open && !document.hidden && !reducedMotion.matches) play();
      };

      video.controls = false;
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;
      video.addEventListener('volumechange', syncSound, options);
      video.addEventListener('play', () => {
        if (!isOpen() || document.hidden) reset();
      }, options);
      button.addEventListener('click', () => {
        if (!isOpen() || document.hidden) return;
        video.muted = !video.muted;
        syncSound();
        if (video.paused) play();
      }, options);
      root?.addEventListener('click', (event) => {
        if (event.target.closest('[data-measure-guide-open], [data-guide-close]')) syncDrawer();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) reset();
      }, options);
      window.addEventListener('pagehide', reset, options);
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) reset();
      }, options);
      const observer = new MutationObserver(syncDrawer);
      observer.observe(drawer, { attributes: true, attributeFilter: ['hidden', 'aria-hidden'] });
      controllers.set(drawer, () => {
        disposed = true;
        reset();
        observer.disconnect();
        events.abort();
        controllers.delete(drawer);
      });
      button.hidden = false;
      syncSound();
      syncDrawer();
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((dispose, drawer) => {
      if (event.target.contains(drawer)) dispose();
    });
  });
})();
